// extracted by mini-css-extract-plugin
var _1 = "src-components-ForgotPasswordForm-_LoadingModalDialog__loadingSpinner--TL4b2C5WsibhVqTL1J8P";
var _2 = "src-components-ForgotPasswordForm-_LoadingModalDialog__loginProcessingModalDialog--n_aLeFAcmSEFGTIhWGVS";
var _3 = "src-components-ForgotPasswordForm-_LoadingModalDialog__spin--mCM_bDQ9ZgdwtvrB7eV3";
export { _1 as "loadingSpinner", _2 as "loginProcessingModalDialog", _3 as "spin" }
